// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { setQueryParams, getQueryParam } from 'Util/Url';
import { fetchQuery } from 'Util/Request';
import BlogPostsQuery from '../../../query/BlogPosts.query';

import NewEvents from './NewEvents.component';

class NewEventsContainer extends PureComponent {
    monthMap = {
        '01': __('January'),
        '02': __('Febrary'),
        '03': __('March'),
        '04': __('April'),
        '05': __('May'),
        '06': __('June'),
        '07': __('July'),
        '08': __('August'),
        '09': __('September'),
        '10': __('October'),
        '11': __('November'),
        '12': __('December')
    };

    state = {
        month_sort_options: [],
        selectedMonth: 0,
        isLoading: false
    }


    componentDidMount() {
        this.requestAllPages();
    }

    isBetweenDates(start, end, selectedOption = "") {
        const startDate = new Date(start);
        startDate.setUTCDate(1);
        startDate.setUTCHours(0, 0, 0, 0);
        const endDate = new Date(end);
        endDate.setUTCDate(1);
        endDate.setUTCHours(0, 0, 0, 0);
        const selection = new Date(selectedOption);

        if (startDate.getTime() <= selection.getTime() && selection.getTime() <= endDate.getTime())
            return true;
        return false;
    }

    requestDropDownValues() {
        const { category_id } = this.props;
        let options = category_id ? { filter: { category_id: { eq: category_id } } } : {};
        options.pageSize = 300;
        options.currentPage = 1;
        options.forEvents = true;

        return fetchQuery(BlogPostsQuery.getQuery(options)).then((data) => {
            const { posts } = data;
            if (Object.keys(posts).length) {
                const { items } = posts;
                let monthArray = [];
                items.map(
                    item => {
                        const { event_start_date, event_end_date, publish_time } = item;
                        if (!event_start_date && !event_end_date && publish_time) {
                            monthArray.push(`${publish_time.split('-')[0]}-${publish_time.split('-')[1]}`);
                        }
                        if (event_start_date && !event_end_date) {
                            monthArray.push(`${event_start_date.split('-')[0]} ${event_start_date.split('-')[1]}`);
                        }
                        if (!event_start_date && event_end_date) {
                            monthArray.push(`${event_end_date.split('-')[0]} ${event_end_date.split('-')[1]}`);
                        }
                        if (event_start_date && event_end_date) {
                            let current = new Date(event_start_date);
                            current.setUTCDate(1);
                            current.setUTCHours(0, 0, 0, 0);
                            let toDate = new Date(event_end_date);
                            while (current.getTime() <= toDate.getTime()) {
                                monthArray.push(current.getUTCFullYear() + "-" + `${current.getUTCMonth() + 1}`.padStart(2, "0"));
                                current.setUTCMonth(current.getUTCMonth() + 1);
                            }
                        }
                    }
                );
                function onlyUnique(value, index, self) {
                    return self.indexOf(value) === index;
                }
                let monthArrayUnique = monthArray.filter(onlyUnique).sort().reverse();
                let month_sort_options = [];
                monthArrayUnique.map((value) => month_sort_options.push({ id: value, value: value, label: `${value.split('-')[0]} ${this.monthMap[value.split('-')[1]]}` }));

                if (month_sort_options.length) {
                    this.setState({
                        month_sort_options,
                    });
                }
            }
        });
    }


    requestAllPages() {
        const { requestPosts, category_id } = this.props;
        let options = category_id ? { filter: { category_id: { eq: category_id } } } : {};
        options.pageSize = 300;
        options.currentPage = 1;
        options.forEvents = true;
        options.sortFiled = "event_start_date";

        if (!options.filter)
            options.filter = {};
        // new Date().getFullYear() - 1 SET start year as current and to see all events of current year
        options.filter.publish_time = {
            gteq: '2000' + "-01-01 00:00:00",
            lteq: new Date().getFullYear() + 1 + "-01-01 00:00:00"
        };
        this.setState({ isLoading: true })
        let self = this;
        setTimeout(
            () => {
                requestPosts(options);
                self.setState({ isLoading: false })
            },
            100
        );
        this.requestDropDownValues();
    }

    containerFunctions = {
        onDropDownChange: this.onDropDownChange.bind(this),
        isBetweenDates: this.isBetweenDates.bind(this)
    };

    onDropDownChange(value) {
        const { selectedMonth } = this.state;
        if (selectedMonth !== value) {
            return this.setState({ selectedMonth: value });
        }
        this.setState({ selectedMonth: 0 })
    }

    containerProps = () => {
        const { selectedMonth, isLoading, month_sort_options } = this.state;

        return { selectedMonth, isLoading, month_sort_options }
    };

    _getPageFromUrl() {
        const { location } = this.props;
        return +(getQueryParam('page', location) || 1);
    }

    render() {
        return (
            <NewEvents
                {...this.props}
                {...this.containerFunctions}
                {...this.containerProps()}
            />
        );
    }
}

export default NewEventsContainer;
